import React from 'react';
import PartAddEditModal from './partmasters-add-edit';
import PartmastersPrintModal from './partmasters-print-modal';

import { MODAL_TYPES } from 'Feature/components/app-modals';
import UploadDrawing from './upload-drawing';

const { PARTS_ADD_EDIT, PARTS_PRINT } = MODAL_TYPES;

const PartModals = () => {
  return (
    <>
      <PartAddEditModal modalId={PARTS_ADD_EDIT} />
      <PartmastersPrintModal modalId={PARTS_PRINT} />
    </>
  );
};

export default PartModals;
